import { Container, Row, Col } from "react-bootstrap";
import Symbol from "../dashboard/card/Symbol";
import { Link } from "react-router-dom";

interface SessionTileProps {
    icon: React.ReactNode;
    name: string;
    date: Date | string;
    id: string;
    sensorId: string;
    isSelectable?: boolean;
    isSelected?: boolean;
    onToggleSelect?: (id: string) => void;
}

export default function SessionTile({ icon, name, date, id, sensorId, isSelectable, isSelected, onToggleSelect }: SessionTileProps) {

    if (typeof date === "string") {
        date = new Date(date);
    }

    const handleClick = (e: React.MouseEvent) => {
        if (isSelectable && onToggleSelect) {
            e.preventDefault();
            onToggleSelect(id);
        }
    };

    const tileClasses = [
        "session-tile p-4 d-flex justify-content-center text-center",
        isSelectable ? "session-tile--selectable" : "",
        isSelected ? "session-tile--selected" : "",
    ].filter(Boolean).join(" ");

    return (
        <Container className={tileClasses} onClick={handleClick} style={{ position: 'relative' }}>
            {isSelectable && (
                <div className="session-tile__checkbox" onClick={e => e.stopPropagation()}>
                    <input
                        type="checkbox"
                        checked={!!isSelected}
                        onChange={() => onToggleSelect?.(id)}
                        style={{ width: 18, height: 18, cursor: 'pointer' }}
                        aria-label={`Select session ${name}`}
                    />
                </div>
            )}
            <Row>
                <Col>
                    <Row className="pb-2">
                        <Col className="text-center d-flex justify-content-center"><Symbol symbol={icon} /></Col>
                    </Row>
                    <Row className="pb-2">
                        <Col><span className="session-tile-title">{name}</span></Col>
                    </Row>
                    <Row className="pb-2">
                        <Col><span className="session-tile-date">{date.toLocaleDateString()}</span></Col>
                    </Row>
                    {!isSelectable && (
                        <Row>
                            <Col><Link className="wind-link" to={"/sessions/" + id + "?sensorId=" + sensorId}>View</Link></Col>
                        </Row>
                    )}
                </Col>
            </Row>
        </Container>
    );
}
